export default __webpack_public_path__ + "static/media/AppStoreBadgeBlack.98ddf27b.svg";